export const FETCH_ROOMLIST_REQUEST = "FETCH_ROOMLIST_REQUEST";
export const FETCH_ROOMLIST_SUCCESS = "FETCH_ROOMLIST_SUCCESS";
export const FETCH_ROOMLIST_FAILURE = "FETCH_ROOMLIST_FAILURE";
